import { Box, Button, Typography, SxProps } from '@mui/material';
import {
  code,
  countBox,
  descText,
  errorText,
  infoText,
  infoTextTimer,
  resent,
  timer,
  warningBox,
} from 'app/components/AsanImzaComponent/ConfirmAsanImza.sx';
import WarningIcon from 'app/components/Icons/WarningIcon';
import BackButton from 'app/components/BackButton';
import React, { Dispatch, SetStateAction } from 'react';
import useConfirmAsanImza from 'app/components/AsanImzaComponent/useConfirmAsanImza';
import CountdownTimer from 'app/components/CountdownTimer';
import SuccessModal from 'app/components/SuccessModal';
import logger from 'app/utils/logger';

interface Props {
  verifyCode?: string;
  asanModalType?: string;
  btnSx?: SxProps;
  close?: Dispatch<SetStateAction<boolean>>;
  timerTime?: any;
  pathUrl?: any;
  businessKey?: any;
}
const AsanImza = (props: Props) => {
  const { verifyCode, asanModalType, btnSx, close, timerTime, pathUrl, businessKey } = props;
  const {
    t,
    handleRepeatCode,
    dataAsanImza,
    data,
    handleCancel,
    successModal,
    setSuccessModal,
    errorModal,
    setErrorModal,
  } = useConfirmAsanImza({
    pathUrl,
    businessKey,
    asanModalType,
  });

  logger.log(dataAsanImza?.text);

  if (successModal) {
    return (
      <SuccessModal
        successText={'Ödəniş uğurla imzalandı!'}
        open={successModal}
        close={setSuccessModal}
        sign={true}
        closeAsan={close}
      />
    );
  } else if (errorModal) {
    return (
      <SuccessModal
        successText={'Uğursuz əməliyyat'}
        open={errorModal}
        close={setErrorModal}
        sign={false}
        unsuccess={true}
        closeAsan={close}
      />
    );
  } else {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Box>
          {asanModalType !== 'transfer' && <Typography sx={infoText}>{t('confirm.confirmAsanImza')}</Typography>}
          <Typography sx={descText}>{t('confirm.asanImzaDesc')}</Typography>
          <Typography sx={code}>
            {data?.verification_code !== undefined ? data?.verification_code : verifyCode}
          </Typography>
          <CountdownTimer
            repeat={handleRepeatCode}
            timerTime={data?.timer !== undefined ? data?.timer : timerTime}
            errorCase={dataAsanImza?.result === 'error'}
          />
          {dataAsanImza?.error && (
            <Box sx={warningBox}>
              <WarningIcon sx={{ mr: '16px' }} />
              <Typography sx={errorText}>{dataAsanImza?.error && dataAsanImza?.error.text}</Typography>
            </Box>
          )}
        </Box>
        {asanModalType === 'transfer' ? (
          <Button
            sx={btnSx}
            color={'secondary'}
            onClick={() => {
              handleCancel();
              close(false);
            }}
          >
            Bağla
          </Button>
        ) : (
          <BackButton btnSx={btnSx} text={'confirm.back'} asan={true} cancel={handleCancel} />
        )}
      </Box>
    );
  }
};

export default AsanImza;
